import { Flex, Text } from '@chakra-ui/react';
import loader from 'assets/img/loader.svg';
import styled from 'styled-components';
import { messages } from './loadingData';

const StyledImg = styled.img`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 999;
	width: 80px;
	height: 80px;
`;

type LoaderProps = {
	loading?: boolean;
	hasText?: boolean;
};
function Loader(props: LoaderProps) {
	const { loading = true, hasText = false } = props;

	const randomMessage = Math.floor(Math.random() * messages.length);

	if (hasText) {
		return (
			<Flex
				justifyContent={'center'}
				alignItems='center'
				height={'100vh'}
				flexDirection='column'
			>
				<img src={loader} height='80px' width='80px' alt='loader' />
				{/* <Text color='red'>{generateRandomMessage()}</Text> */}
			</Flex>
		);
	}

	return <>{loading && <StyledImg src={loader} alt='Loader' />}</>;
}
export default Loader;
